// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"5582a9a7","977":"af1998d0"}[chunkId] + ".chunk.js";
};